// eslint-disable-next-line no-restricted-imports
export * from '@auth0/auth0-react';
